import { useQuery } from "@tanstack/react-query";
import { crmApi } from "../api/client";
import { useSelectedProject } from "../contexts/SelectedProjectProvider";
import { useSelectedCompany } from "../contexts/SelectedCompanyProvider";

const ACTIVITIES_KEY = ["crm", "org-activities"];

// Cross-lead activity feed. Per-lead activity (lead drawer) uses
// useLeadActivities in useLeads.js — different endpoint, different cache key.
export function useActivities({ type, types, leadId, userId, from, to, limit = 20, skip = 0 } = {}) {
  const { projectId } = useSelectedProject();
  const { companyQueryParams } = useSelectedCompany();
  return useQuery({
    queryKey: [...ACTIVITIES_KEY, { type, types, leadId, userId, from, to, limit, skip, projectId, companyQueryParams }],
    queryFn: async () => {
      const params = { limit, skip, ...companyQueryParams };
      if (type) params.type = type;
      if (Array.isArray(types) && types.length) params.types = types.join(",");
      if (leadId) params.leadId = leadId;
      if (userId) params.userId = userId;
      if (from) params.from = from;
      if (to) params.to = to;
      if (projectId) params.projectId = projectId;
      const { data } = await crmApi.get("/activities", { params });
      return data;
    },
    keepPreviousData: true,
  });
}

export function useDashboard() {
  const { projectId } = useSelectedProject();
  const { companyQueryParams } = useSelectedCompany();
  return useQuery({
    queryKey: ["crm", "dashboard", "overview", { projectId, companyQueryParams }],
    queryFn: async () => (await crmApi.get("/dashboard/overview", {
      params: { ...(projectId ? { projectId } : {}), ...companyQueryParams },
    })).data,
    staleTime: 30_000,
  });
}
